import { debugLog } from '@schibsted-nmp/advertising-shared';

const STAGGER_TIME = 16; // ~1 frame. 0ms also works, but this is safer.
let chain = Promise.resolve();
let currentAfsController = new AbortController();

export function cancelAfsRequests() {
  debugLog('Cancelling active AFS requests');
  currentAfsController.abort();
  // Create a fresh controller for the incoming new filter batch
  currentAfsController = new AbortController();
  // Reset the chain to prevent queued requests from executing
  chain = Promise.resolve();
}

export function staggerAfsRequests(fn: () => void) {
  // Staggering prevents page from hanging upon first filter interaction
  // Single chain is for all AFS placements on the page
  const controller = currentAfsController;

  chain = chain
    .then(
      () =>
        new Promise<void>((res, rej) => {
          if (controller.signal.aborted) {
            rej(new DOMException('AFS request aborted', 'AbortError'));
            return;
          }

          const timeoutId = setTimeout(() => {
            if (controller.signal.aborted) {
              rej(new DOMException('AFS request aborted', 'AbortError'));
            } else {
              res();
            }
          }, STAGGER_TIME);

          // Cancel timeout if aborted
          controller.signal.addEventListener('abort', () => {
            clearTimeout(timeoutId);
            rej(new DOMException('AFS request aborted', 'AbortError'));
          });
        })
    )
    .then(() => {
      if (controller.signal.aborted) {
        throw new DOMException('AFS request aborted', 'AbortError');
      }
      fn();
    })
    .catch((err: unknown) => {
      if (err instanceof DOMException && err.name === 'AbortError') {
        debugLog('AFS request cancelled due to filter change');
        return;
      }
      console.error('AFS request failed', err);
    }); // prevent chain break
}
